import React from 'react';
import UnavailableFeature from '../../../../components/misc/UnavailableFeature';

export default function CommunityFinancesPage() {
  return <UnavailableFeature />;
}
